import React from 'react'
import { Container, Row, Col, Input, Button, Modal, ModalBody, ModalFooter, ModalHeader, Label } from 'reactstrap';
// import PEAppraisalComparisonToValuations from '../components/Reports/PEAppraisalComparisonToValuations';
import FundDateToDateAppraisal from '../components/Reports/FundDateToDateAppraisal';
import FundListings from '../components/Reports/FundListings';
import PEFundTransactionsAnalysis from '../components/Reports/PEFundTransactionsAnalysis';
import InvestorAppraisals from '../components/Reports/InvestorAppraisals';
import InvestorLog from '../components/Reports/InvestorLog';
import CommitmentsLedger from '../components/Reports/CommitmentsLedger';
import TransactionList from '../components/Reports/TransactionList';
import * as XLSX from "xlsx-js-style";
import { CSVLink } from "react-csv";
import 'bootstrap/dist/css/bootstrap.css';

class Reports extends React.Component {

    constructor(props) {
        super(props);

        this.path = String(this.props.location.pathname).split('/');
        if (this.path[2] != null) {
            this.path[3] = this.path.filter((i, index) => index > 2).join('/');
            this.path.splice(4, 1000);
        }

        let state = {
            ...this.state,
            reportId: '',
            sheetData: [],
            sheetStyles: [],
            fileName: '',
            path: '',
            title: (this.props.setReport != null && this.props.setReport !== '') ? this.props.setReport : '',
            selector: this.path[3] != null ? this.path[3] : null,
            reports: [],
            headers: [],
            filterClients: [],
            isOpen: false,
            cb: null
        };

        this.state = {
            ...state
        };
    }

    componentDidMount = () => {
        this.props.log('Reports.js/componentDidMount');
        this.reports = [
            // {
            //     title: 'PE Appraisal Comparison to Valuation', path: 'pe-appraisal-comparison-to-valuation', /*activeServices: true, */module:
            //         <PEAppraisalComparisonToValuations {...this.props} passData={this.passData} changeSelector={this.onChangeSelector} selector={this.state.selector}
            //             filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback} />
            // },
            {
                title: 'Commitments Ledger', path: 'commitments-ledger', /*activeServices: true, */module:
                    <CommitmentsLedger {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Fund Date to Date Appraisal', path: 'fund-date-to-date-appraisal', /*activeServices: true, */module:
                    <FundDateToDateAppraisal {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Fund Listings', path: 'fund-listings', /*activeServices: true, */module:
                    <FundListings {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Fund Transactions Analysis', path: 'fund-transactions-analysis', /*activeServices: true, */module:
                    <PEFundTransactionsAnalysis {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Investor Appraisals', path: 'investor-appraisals', /*activeServices: true, */module:
                    <InvestorAppraisals {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Investor Log', path: 'investor-log', hide: true, module:
                    <InvestorLog {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
            {
                title: 'Transaction Lists', path: 'transaction-lists', /*activeServices: true, */module:
                    <TransactionList {...this.props} passData={this.passData} passHeaders={this.passHeaders}
                        changeSelector={this.onChangeSelector} selector={this.state.selector}
                        filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}
                        orderEntries={this.orderEntries} setSort={this.setSort} />
            },
        ];
        this.init();
        if (this.props.setCallback != null) this.props.setCallback(this.props.tab, this.init);
    }

    init = () => {
        this.props.log('Reports.js/init');
        const reportIndex = (this.props.setReport != null && this.props.setReport !== '') ? this.reports.findIndex(report => report.path === this.props.setReport) :
            ((this.path[2] != null) ? this.reports.findIndex(report => report.path === this.path[2]) : -1);
        this.setState({
            reportId: (reportIndex > -1) ?
                this.reports[reportIndex].path : '',
            reports: this.reports,
            path: reportIndex > -1 ? this.reports[reportIndex].path : '',
            title: reportIndex > -1 ? this.reports[reportIndex].title : ''
        }, () => {
            this.filterClients()
        })
    }

    filterClientsCallback = (cb) => {
        this.props.log('Reports.js/filterClientsCallback (cb)', cb);
        this.setState({
            filterClientsCallback: cb
        });
    }

    orderEntries = (arr, obj, dbField) => {
        this.props.log('Reports.js/orderEntries (arr,obj, dbField)', arr, obj, dbField);

        if (obj != null) {
            if (obj.type === 'currency' || obj.type === 'number') {
                arr.sort(function (a, b) {
                    var numA = a.data[obj.uniqueId] != null ? parseFloat(a.data[obj.uniqueId]) : '';
                    var numB = b.data[obj.uniqueId] != null ? parseFloat(b.data[obj.uniqueId]) : '';
                    if (obj == null || obj.asc == null || obj.asc) {
                        return (numA < numB) ? -1 : (numA > numB) ? 1 : 0;
                    } else {
                        return (numA < numB) ? 1 : (numA > numB) ? -1 : 0;
                    }
                });
            } else {
                arr.sort(function (a, b) {
                    var textA, textB;
                    if (dbField) {
                        textA = a[obj.uniqueId] != null ? a[obj.uniqueId].toUpperCase() : '';
                        textB = b[obj.uniqueId] != null ? b[obj.uniqueId].toUpperCase() : '';
                    } else {
                        textA = a.data[obj.uniqueId] != null ? a.data[obj.uniqueId].toUpperCase() : '';
                        textB = b.data[obj.uniqueId] != null ? b.data[obj.uniqueId].toUpperCase() : '';
                    }
                    if (obj == null || obj.asc == null || obj.asc) {
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    } else {
                        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
                    }
                });
            }
            return arr;
        } else {
            return arr;
        }
    }

    setSort = (field, type, sort, sortAsc, dbField) => {
        this.props.log('Reports.js/setSort (field,type,sort,dbField)', field, type, sort, sortAsc, dbField);
        return ({
            sortAsc: (sort === field) ? !sortAsc : true,
            sortType: type,
            sort: field,
            dbField: dbField
        })
    }

    onChange = (e) => {
        this.props.log('Reports.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.ping();
        this.setState({
            sheetData: [],
            fileName: '',
            reportId: (e.target.value !== '') ? this.state.reports.filter(report => report.path === e.target.value)[0].path : '',
            path: (e.target.value !== '') ? this.state.reports.filter(report => report.path === e.target.value)[0].path : '',
            title: (e.target.value !== '') ? this.state.reports.filter(report => report.path === e.target.value)[0].title : '',
            selector: null
        }, () => this.setLocation());
    }

    onChangeSelector = (e) => {
        this.props.log('Reports.js/onChangeSelector (name, value, e)', e.target.name, e.target.value, e);
        const xe = { ...e };
        this.setState({
            selector: (xe.target.value !== '' && xe.target.value != null) ? xe.target.value : null
        }, () => { this.setLocation(); this.filterClients(); });
    }

    setLocation = () => {
        this.props.log('Reports.js/setLocation');
        window.history.pushState({}, this.state.title, this.props.replaceSpecialChars('/reports/' + this.state.path + (this.state.selector != null ? '/' + this.state.selector : '')))
    }

    getFilterClients = () => {
        this.props.log('Reports.js/getFilterClients');
        return this.state.filterClients;
    }

    passData = (data, fileName, styles = []) => {
        this.props.log('Reports.js/passData (data, fileName)', data, fileName);
        this.setState({
            sheetData: data,
            fileName: fileName,
            sheetStyles: styles
        });
    }

    passHeaders = (data, cb) => {
        this.props.log('Reports.js/passHeaders (data, cb)', data, cb);
        this.setState({
            headers: data,
            cb: cb
        });
    }

    filterClients = () => {
        this.props.log('Reports.js/filterClients');
        this.setState({
            filterClients: this.props.clients
        }, () => { if (this.state.filterClientsCallback) this.state.filterClientsCallback(); });
    }

    getLetters = (str) => {
        this.props.info('Reports.js/getLetters (str)', str);
        return str.replace(/[^a-zA-Z]+/g, '');
    }

    displayReport = () => {
        this.props.log('Reports.js/displayReport (this.state.reportId)', this.state.reportId, this.state.reports.filter(report => report.hide == null || !report.hide));
        return (this.state.reportId !== '') ? this.state.reports.filter(report => report.path === this.state.reportId)[0].module : (<>None</>);
    }

    filterHeaders = () => {
        this.props.log('Reports.js/filterHeaders ()');
        this.setState({ isOpen: true });
    }

    lettersToNumber = (letters) => {
        return letters.split('').reduce((r, a) => r * 26 + parseInt(a, 36) - 9, 0);
    }

    handleExport = () => {
        this.props.log('Reports.js/handleExport');
        const dataGrid = [{ data: [], tab: "Report" }];
        const exportGrid = dataGrid.map(tab => {
            tab.data =
                this.state.sheetData.map(row => row.map(col => { return col != null ? col : '' }));
            return tab;
        })
        let wb = XLSX.utils.book_new();
        exportGrid.forEach((tab) => {
            let ws = XLSX.utils.aoa_to_sheet(tab.data);
            Object.keys(ws).forEach(key => {
                if (typeof (ws[key]) === 'object') {
                    const col = this.lettersToNumber(key.match(/[A-Z]/g).join('')) - 1;
                    const row = parseInt(key.match(/[0-9]/g).join('')) - 1;
                    if (this.state.sheetStyles.length > 0) ws[key] = { ...ws[key], ...this.state.sheetStyles[row][col] }
                }
            })
            ws["!cols"] = this.state.headers.map(col => col.width != null ? { wch: col.width } : { wch: 10 })
            XLSX.utils.book_append_sheet(wb, ws, tab.tab);
        })
        const d = new Date();
        XLSX.writeFile(wb, "ppe-report_" + this.state.fileName + '_' + (d.getMonth() + 1) + '-' + d.getDate() + '-' + d.getFullYear() + '.xlsx')
    }

    changeHeaderVisibility = (index) => {
        this.props.log('Reports.js/changeHeaderVisibility (index)', index);
        this.setState((prevState) => {
            let sel = prevState;
            sel.headers[index].hidden = (sel.headers[index].hidden == null) ? true : !sel.headers[index].hidden;
            return sel;
        }, () => this.state.cb(this.state.headers))
    }

    render = () => {
        this.props.info('Reports.js/render');
        return (
            <>
                <Modal centered isOpen={this.state.isOpen}>
                    <ModalHeader>
                        Filter Report Columns
                    </ModalHeader>
                    <ModalBody>
                        {this.state.headers.map((header, headerIndex) => (
                            <Row key={headerIndex}>
                                <Col className="text-left">
                                    <Label><Input type="checkbox"
                                        checked={header.hidden == null || (header.hidden != null && !header.hidden)}
                                        onChange={() => this.changeHeaderVisibility(headerIndex)}
                                    />{header.display}
                                    </Label>
                                </Col>
                            </Row>
                        ))}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.setState({ isOpen: false })}>
                            OK
                        </Button>
                    </ModalFooter>
                </Modal>
                <Container fluid className="report">
                    {this.props.hideTools == null || !this.props.hideTools ?
                        <Row className="noPrint px-2">
                            <Col md={5}>
                                <Input type="select" name="report" value={this.props.isFieldNull(this.state.reportId)} onChange={(e) => this.onChange(e)}>
                                    <option value="">Select Report</option>
                                    {this.state.reports.filter(report => report.hide == null || !report.hide).map((report, index) => (
                                        <option key={index} value={this.props.isFieldNull(report.path)}>{report.title}</option>
                                    ))}
                                </Input>
                            </Col>
                            <Col md={7} className="text-right">
                                {this.state.sheetData.length > 0 ?
                                    <>
                                        <Button onClick={() => window.print()} color="primary">Print</Button>
                                        <Button onClick={() => this.handleExport()} color="primary">Download XLSX</Button>
                                        <CSVLink
                                            className="btn btn-primary"
                                            data={this.state.sheetData}
                                            filename={"ppe-report_" + this.state.fileName + ".csv"}
                                        >Download CSV</CSVLink></>
                                    : <></>}
                                {this.state.headers.length > 0 ?
                                    <Button onClick={() => this.filterHeaders()} color="primary">Filter Columns</Button>
                                    : null}
                            </Col>
                        </Row> : null}
                    <Row className="mainRow px-3 mt-3 text-left">
                        <Col md={12}>
                            {this.displayReport()}
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default Reports;